import React from 'react'
import { IonButton, IonIcon } from '@ionic/react'
import { cloudOffline } from 'ionicons/icons'
import { useOfflineStatus } from '../../utilities/isOnline.util'

const OfflineIndicator = () => {
  const isOfflineStatus = useOfflineStatus()

  return (
    <>
      {isOfflineStatus && (
        <IonButton color='primary'>
          <IonIcon slot='icon-only' icon={cloudOffline} />
        </IonButton>
      )}
    </>
  )
}

export default OfflineIndicator
